export default "/assets/images/technology-graph-02.svg?faff59da1f15b7f859bab73987fee336";